import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminCtrlVehGeocerca } from 'src/app/models/admin-ctrlvehiculo-geocerca';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';

import { interval } from 'rxjs';
import { AdminCtrlVehEventos } from 'src/app/models/admin-ctrlvehiculo-eventos';

@Component({
  selector: 'app-control-vehiculos-eventos',
  templateUrl: './control-vehiculos-eventos.component.html',
  styleUrls: ['./control-vehiculos-eventos.component.scss']
})
export class ControlVehiculosEventos implements OnInit, OnDestroy {

  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';

  fechalang: any;

  // NUEVA ESTRUCTURA: Array unificado de eventos
  public eventos: any[] = [];

  // Parámetros para eventos especiales (códigos con parametros)
  public parametros = {
    '40': { // Combustible
      umbral_descenso: 10,
      umbral_reposte: 20,
      tiempo_minimo: 5
    },
    '16': { // Exceso velocidad
      maxima: 80,
      tolerancia: 5,
      unidad: 'kmh'
    },
    '28': { // Temperatura
      minima: 10,
      maxima: 50,
      unidad: 'celsius'
    },
    '41': { // Temperatura alta
      minima: 15,
      maxima: 60,
    unidad: 'celsius'
    }
  };

  // Códigos que tienen parámetros especiales
  public eventosConParametros = ['40', '16', '28', '41'];

  // Configuración de paradas e informe completo
  public configuracionParadas = {
    paradas: {
      activo: false,
      tiempo_maximo_parada: 30 // minutos por defecto
    },
    informe_completo: false
  };

  constructor(
    public gtp: Gtp,
    private dialog: MatDialog,
    public ctrlVehiculo: ControlVehiculosService,
  ) {
    this.fechalang = this.gtp.fechalang;
  }

  ngOnInit(): void {
    console.log('🚀 ngOnInit - Control Eventos iniciado');

    // Limpiar estado previo para garantizar recarga completa
    this.eventos = [];
    this.loading = false;

    // Primero cargar eventos, luego configuración
    this.cargarEventos();

    // Suscribirse a cambios de perfil CON MEJOR DETECCIÓN
    this.ctrlVehiculo.getPerfilActualObs().subscribe(perfil => {
      console.log('🔔 Perfil cambió:', perfil);
      if (perfil && perfil.id_perfil) {
        // Dar tiempo para que se actualice el perfil antes de cargar eventos
        setTimeout(() => {
          if (this.eventos.length > 0) {
            this.cargarConfiguracionDesdePerfil(perfil.id_perfil);
            this.cargarConfiguracionParadasInforme(perfil.id_perfil);
          }
        }, 200);
      } else {
        // Si no hay perfil, limpiar configuración
        console.log('🧹 Sin perfil seleccionado - limpiando eventos');
        this.limpiarConfiguracion();
      }
    });

    // NUEVO: Suscribirse a notificaciones de recarga específicas de eventos
    this.ctrlVehiculo.getRecargarEventosObs().subscribe(() => {
      console.log('🔔 Notificación de recarga recibida en componente de eventos');

      const perfilActual = this.ctrlVehiculo.getPerfilActual();
      if (perfilActual && perfilActual.id_perfil) {
        console.log('📥 Recargando configuración del perfil:', perfilActual.id_perfil);

        // Si no hay eventos cargados, cargarlos primero
        if (this.eventos.length === 0) {
          this.cargarEventos();
          // Esperar a que se carguen los eventos antes de cargar configuración
          setTimeout(() => {
            if (this.eventos.length > 0) {
              this.cargarConfiguracionDesdePerfil(perfilActual.id_perfil);
              this.cargarConfiguracionParadasInforme(perfilActual.id_perfil);
            }
          }, 500);
        } else {
          // Si ya hay eventos, cargar configuración directamente
          this.cargarConfiguracionDesdePerfil(perfilActual.id_perfil);
          this.cargarConfiguracionParadasInforme(perfilActual.id_perfil);
        }
      } else {
        console.warn('⚠️ No hay perfil actual para recargar eventos');
      }
    });
  }

  ngOnDestroy():void{
    console.log('🧹 Destruyendo componente Control Eventos');
  }

  cargarEventos() {
    console.log('📋 Cargando eventos desde eventos_equipos...');

    this.ctrlVehiculo.getListaEventos().subscribe(res => {
      console.log('📦 Eventos obtenidos:', res['rows']?.length);

      this.eventos = [];
      res['rows'].forEach(val => {
        const evento = {
          codigo: val.cod_evento,
          descripcion: val.des_evento,
          estado: false, // Por defecto inactivo
          parametros: this.eventosConParametros.includes(val.cod_evento) ?
            this.parametros[val.cod_evento] : undefined
        };
        this.eventos.push(evento);
      });

      console.log('✅ Eventos cargados:', this.eventos.length);
      console.log('🎯 Con parámetros:', this.eventos.filter(e => e.parametros).map(e => e.codigo));

      // DESPUÉS de cargar eventos, cargar configuración del perfil actual
      const perfilActual = this.ctrlVehiculo.getPerfilActual();
      if (perfilActual && perfilActual.id_perfil) {
        console.log('🔄 Cargando configuración del perfil actual:', perfilActual.id_perfil);
        this.cargarConfiguracionDesdePerfil(perfilActual.id_perfil);
        this.cargarConfiguracionParadasInforme(perfilActual.id_perfil);
      }
    }, error => {
      console.error('❌ Error cargando eventos:', error);
      this.gtp.showError('Error al cargar la lista de eventos');
    });
  }

  cargarConfiguracionDesdePerfil(idPerfil) {
    console.log('🔍 Cargando configuración del perfil:', idPerfil);

    // Validar que los eventos estén cargados
    if (!this.eventos || this.eventos.length === 0) {
      console.warn('⚠️ No hay eventos cargados, reintentando en 500ms...');
      setTimeout(() => {
        if (this.eventos && this.eventos.length > 0) {
          this.cargarConfiguracionDesdePerfil(idPerfil);
        }
      }, 500);
      return;
    }

    // PRIMERO: Limpiar configuración anterior
    this.limpiarConfiguracion();

    this.ctrlVehiculo.getConfiguracionEventosPerfil(idPerfil).subscribe(
      response => {
        console.log('🔍 RESPUESTA COMPLETA del backend:', response);
        console.log('🔍 Tipo de respuesta:', typeof response);
        console.log('🔍 Keys de respuesta:', Object.keys(response || {}));

        // Verificar diferentes estructuras posibles
        if (response && response['rows']) {
          console.log('🔍 response.rows:', response['rows']);
          console.log('🔍 Keys de rows:', Object.keys(response['rows'] || {}));

          if (response['rows']['eventos']) {
            console.log('🔍 response.rows.eventos (raw):', response['rows']['eventos']);
          }
        }

        if (response && response['rows'] && response['rows']['eventos']) {
          let eventosGuardados;
          try {
            const eventosRaw = response['rows']['eventos'];
            console.log('📄 Eventos raw antes del parse:', eventosRaw);
            console.log('📄 Tipo de datos eventos:', typeof eventosRaw);

            // Verificar si ya es un array (no necesita parse) o es string (necesita parse)
            if (Array.isArray(eventosRaw)) {
              console.log('✅ Eventos ya son array de objetos - usando directamente');
              eventosGuardados = eventosRaw;
            } else if (typeof eventosRaw === 'string') {
              console.log('🔄 Eventos son string JSON - parseando');
              eventosGuardados = JSON.parse(eventosRaw || '[]');
            } else {
              console.log('❌ Tipo de datos eventos no reconocido:', typeof eventosRaw);
              this.gtp.showWarning('Formato de eventos no reconocido');
              return;
            }

            console.log('📊 Eventos procesados exitosamente:', eventosGuardados);
          } catch (error) {
            console.error('❌ Error procesando eventos:', error);
            console.error('❌ Datos que causaron error:', response['rows']['eventos']);
            this.gtp.showWarning('Error al cargar configuración de eventos del perfil');
            return;
          }

          console.log('📊 Configuración cargada:', eventosGuardados);

          if (Array.isArray(eventosGuardados)) {
            // FORMATO NUEVO: Array de objetos {codigo, descripcion, estado, parametros?}
            if (eventosGuardados.length > 0 && eventosGuardados[0].codigo) {
              console.log('🆕 Formato nuevo detectado');
              this.aplicarConfiguracionNueva(eventosGuardados);
            }
            // FORMATO LEGACY: Array de strings ["20", "21", "TEMP_ALERT"]
            else if (eventosGuardados.length > 0 && typeof eventosGuardados[0] === 'string') {
              console.log('🔄 Formato legacy detectado, convirtiendo...');
              this.aplicarConfiguracionLegacy(eventosGuardados);
            }
            else {
              console.log('📝 Array vacío - perfil sin eventos configurados');
            }
          }
          // FORMATO MIXTO: {eventos_normales: [...], eventos_especiales: {...}}
          else if (eventosGuardados.eventos_normales) {
            console.log('🔄 Formato mixto detectado, convirtiendo...');
            this.aplicarConfiguracionMixta(eventosGuardados);
          }
          else {
            console.log('📝 Configuración vacía o formato desconocido');
          }

          // Mostrar estadísticas de carga
          const activos = this.eventos.filter(e => e.estado);
          const conParametros = this.eventos.filter(e => e.estado && e.parametros);

          console.log(`✅ Configuración aplicada: ${activos.length} eventos activos, ${conParametros.length} con parámetros`);

          if (activos.length > 0) {
            this.gtp.showInfo(
              `📋 Configuración cargada: ${activos.length} eventos activos${conParametros.length > 0 ? `, ${conParametros.length} con parámetros` : ''}`
            );
          }
        } else {
          console.log('⚠️ Perfil sin configuración de eventos');
          console.log('⚠️ Estructura de respuesta:', {
            hasResponse: !!response,
            hasRows: !!(response && response['rows']),
            hasEventos: !!(response && response['rows'] && response['rows']['eventos']),
            eventosValue: response && response['rows'] ? response['rows']['eventos'] : 'N/A'
          });

          // Verificar si hay datos pero sin eventos
          if (response && response['rows'] && !response['rows']['eventos']) {
            console.log('📝 Perfil existe pero sin eventos configurados - inicializando vacío');
            this.gtp.showInfo('Perfil sin eventos configurados. Selecciona los eventos que deseas activar.');
          } else {
            console.log('❌ Estructura de respuesta inesperada');
            this.gtp.showWarning('No se pudo cargar la configuración del perfil');
          }
        }
      },
      error => {
        console.error('❌ Error cargando configuración:', error);
        this.gtp.showError('Error al cargar configuración de eventos del perfil');
      }
    );
  }

  aplicarConfiguracionNueva(eventosGuardados) {
    // Aplicar configuración directamente
    eventosGuardados.forEach(eventoGuardado => {
      const evento = this.eventos.find(e => e.codigo === eventoGuardado.codigo);
      if (evento) {
        evento.estado = eventoGuardado.estado;
        if (eventoGuardado.parametros && evento.parametros) {
          evento.parametros = { ...evento.parametros, ...eventoGuardado.parametros };
        }
      }
    });
    console.log('✅ Configuración nueva aplicada');
  }

  aplicarConfiguracionLegacy(eventosGuardados) {
    // Convertir códigos legacy a códigos reales
    const conversion = {
      'TEMP_ALERT': '28',
      'TEMPERATURA': '28',
      'FUEL_ALERT': '40',
      'NIVEL_COMBUSTIBLE': '40',
      'SPEED_ALERT': '16',
      'EXCESO_VELOCIDAD': '16'
    };

    eventosGuardados.forEach(codigo => {
      const codigoReal = conversion[codigo] || codigo;
      const evento = this.eventos.find(e => e.codigo === codigoReal);
      if (evento) {
        evento.estado = true;
      }
    });
    console.log('✅ Configuración legacy convertida');
  }

  aplicarConfiguracionMixta(configuracion) {
    // Activar eventos normales
    if (configuracion.eventos_normales) {
      configuracion.eventos_normales.forEach(codigo => {
        const evento = this.eventos.find(e => e.codigo === codigo);
        if (evento) {
          evento.estado = true;
        }
      });
    }

    // Activar eventos especiales con parámetros
    if (configuracion.eventos_especiales) {
      // Temperatura
      if (configuracion.eventos_especiales.temperatura) {
        const evento28 = this.eventos.find(e => e.codigo === '28');
        if (evento28) {
          evento28.estado = true;
          if (evento28.parametros) {
            evento28.parametros = { ...evento28.parametros, ...configuracion.eventos_especiales.temperatura };
          }
        }
      }

      // Combustible
      if (configuracion.eventos_especiales.combustible) {
        const evento40 = this.eventos.find(e => e.codigo === '40');
        if (evento40) {
          evento40.estado = true;
          if (evento40.parametros) {
            evento40.parametros = { ...evento40.parametros, ...configuracion.eventos_especiales.combustible };
          }
        }
      }

      // Velocidad
      if (configuracion.eventos_especiales.velocidad) {
        const evento16 = this.eventos.find(e => e.codigo === '16');
        if (evento16) {
          evento16.estado = true;
          if (evento16.parametros) {
            evento16.parametros = { ...evento16.parametros, ...configuracion.eventos_especiales.velocidad };
          }
        }
      }
    }
    console.log('✅ Configuración mixta convertida');
  }

  saveParams() {
    this.loading = true;

    const perfilActual = this.ctrlVehiculo.getPerfilActual();
    if (!perfilActual || !perfilActual.id_perfil) {
      this.loading = false;
      console.error('No hay perfil seleccionado');
      this.gtp.showWarning('No hay perfil seleccionado');
      return;
    }

    // Validar parámetros de eventos especiales
    const eventosInvalidos = this.eventos.filter(evento => {
      if (!evento.estado || !evento.parametros) return false;
      return !this.validarParametros(evento);
    });

    if (eventosInvalidos.length > 0) {
      this.loading = false;
      const codigosInvalidos = eventosInvalidos.map(e => e.codigo).join(', ');
      this.gtp.showError(`Parámetros inválidos en eventos: ${codigosInvalidos}`);
      return;
    }

    const datosGuardar = {
      id_perfil: perfilActual.id_perfil,
      eventos: this.eventos // Enviar array completo con estructura optimizada
    };

    console.log('📤 Guardando configuración:', datosGuardar);

    this.ctrlVehiculo.guardarConfiguracionEventos(datosGuardar).subscribe(
      response => {
        this.loading = false;
        if (response['error']) {
          console.error('❌ Error:', response['msg']);
          this.gtp.showError(`Error: ${response['msg'] || 'Error al guardar eventos'}`);
        } else {
          console.log('✅ Guardado exitoso');
          const activos = this.eventos.filter(e => e.estado);
          const conParametros = this.eventos.filter(e => e.estado && e.parametros);

          this.gtp.showSuccess(
            `🎉 Eventos guardados correctamente!\n` +
            `📊 ${activos.length} eventos activos\n` +
            `⚙️ ${conParametros.length} con parámetros especiales`
          );
        }
      },
      error => {
        this.loading = false;
        console.error('❌ Error request:', error);
        this.gtp.showError('Error de conexión al guardar eventos. Intente nuevamente.');
      }
    );
  }

  validarParametros(evento): boolean {
    if (!evento.parametros) return true;

    switch(evento.codigo) {
      case '28': // Temperatura
      case '41': // Temperatura alta
        return evento.parametros.minima !== null &&
               evento.parametros.maxima !== null &&
               evento.parametros.minima < evento.parametros.maxima;

      case '40': // Combustible
        return evento.parametros.umbral_descenso > 0 &&
               evento.parametros.umbral_reposte > 0 &&
               evento.parametros.tiempo_minimo > 0;

      case '16': // Velocidad
        return evento.parametros.maxima > 0 &&
               evento.parametros.tolerancia >= 0;

      default:
        return true;
    }
  }

  // MÉTODOS PARA EL TEMPLATE
  get eventosActivos() {
    return this.eventos.filter(e => e.estado);
  }

  get eventosConParametrosActivos() {
    return this.eventos.filter(e => e.estado && e.parametros);
  }

  get totalEventos() {
    return this.eventos.length;
  }

  get totalEventosActivos() {
    return this.eventosActivos.length;
  }

  get totalEventosConParametros() {
    return this.eventosConParametrosActivos.length;
  }

  get tieneEventosActivos() {
    return this.eventosActivos.length > 0;
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  limpiarConfiguracion() {
    // Resetear todos los eventos a inactivo
    this.eventos.forEach(evento => {
      evento.estado = false;
    });

    // Limpiar configuración de paradas e informe completo
    this.configuracionParadas = {
      paradas: { activo: false, tiempo_maximo_parada: 30 },
      informe_completo: false
    };

    console.log('🧹 Configuración limpiada');
  }

  /**
   * Método público para recargar configuración desde componente padre
   */
  recargarConfiguracion() {
    console.log('🔄 Recarga manual solicitada');
    const perfilActual = this.ctrlVehiculo.getPerfilActual();
    if (perfilActual && perfilActual.id_perfil && this.eventos.length > 0) {
      this.cargarConfiguracionDesdePerfil(perfilActual.id_perfil);
      this.cargarConfiguracionParadasInforme(perfilActual.id_perfil);
    } else if (this.eventos.length === 0) {
      // Si no hay eventos, cargarlos primero
      this.cargarEventos();
    } else {
      console.warn('⚠️ No hay perfil seleccionado para recargar');
      this.limpiarConfiguracion();
    }
  }

  // ===== MÉTODOS PARA PARADAS E INFORME COMPLETO =====

  /**
   * Cargar configuración de paradas e informe completo desde el perfil
   */
  cargarConfiguracionParadasInforme(idPerfil: number) {
    console.log('🚏 Cargando configuración de paradas e informe completo:', idPerfil);

    this.ctrlVehiculo.getConfiguracionParadasInforme(idPerfil).subscribe(
      response => {
        if (response && !response['error'] && response['data']) {
          const data = response['data'];
          // Parsear paradas si viene como string JSON
          let paradasConfig = data.paradas;
          if (typeof paradasConfig === 'string') {
            try {
              paradasConfig = JSON.parse(paradasConfig);
            } catch (e) {
              paradasConfig = { activo: false, tiempo_maximo_parada: 30 };
            }
          } else if (typeof paradasConfig === 'boolean') {
            // Migrar de boolean a objeto
            paradasConfig = { activo: paradasConfig, tiempo_maximo_parada: 30 };
          } else if (!paradasConfig) {
            paradasConfig = { activo: false, tiempo_maximo_parada: 30 };
          }

          this.configuracionParadas = {
            paradas: paradasConfig,
            informe_completo: data.informe_completo || false
          };
          console.log('✅ Configuración paradas/informe cargada:', this.configuracionParadas);
        } else {
          console.warn('⚠️ Error o sin datos de paradas/informe:', response);
          this.configuracionParadas = {
            paradas: { activo: false, tiempo_maximo_parada: 30 },
            informe_completo: false
          };
        }
      },
      error => {
        console.error('❌ Error cargando configuración paradas/informe:', error);
        this.configuracionParadas = {
          paradas: { activo: false, tiempo_maximo_parada: 30 },
          informe_completo: false
        };
      }
    );
  }

  /**
   * Manejar cambio en checkbox de paradas
   */
  onParadasChange() {
    console.log('🚏 Cambio en paradas:', this.configuracionParadas.paradas);
    this.guardarConfiguracionParadasInforme();
  }

  /**
   * Manejar cambio en tiempo máximo de parada
   */
  onTiempoMaximoParadaChange() {
    console.log('⏱️ Cambio en tiempo máximo parada:', this.configuracionParadas.paradas.tiempo_maximo_parada);
    if (this.configuracionParadas.paradas.activo) {
      this.guardarConfiguracionParadasInforme();
    }
  }

  /**
   * Manejar cambio en checkbox de informe completo
   */
  onInformeCompletoChange() {
    console.log('📋 Cambio en informe completo:', this.configuracionParadas.informe_completo);
    this.guardarConfiguracionParadasInforme();
  }

  /**
   * Toggle paradas al hacer click en el texto
   */
  toggleParadas() {
    this.configuracionParadas.paradas.activo = !this.configuracionParadas.paradas.activo;
    this.onParadasChange();
  }

  /**
   * Toggle informe completo al hacer click en el texto
   */
  toggleInformeCompleto() {
    this.configuracionParadas.informe_completo = !this.configuracionParadas.informe_completo;
    this.onInformeCompletoChange();
  }

  /**
   * Guardar configuración de paradas e informe completo
   */
  guardarConfiguracionParadasInforme() {
    const perfilActual = this.ctrlVehiculo.getPerfilActual();
    if (!perfilActual || !perfilActual.id_perfil) {
      console.error('No hay perfil seleccionado');
      this.gtp.showWarning('No hay perfil seleccionado');
      return;
    }

    const datos = {
      paradas: this.configuracionParadas.paradas,
      informe_completo: this.configuracionParadas.informe_completo
    };

    console.log('💾 Guardando configuración paradas/informe:', datos);

    this.ctrlVehiculo.actualizarParadasInforme(perfilActual.id_perfil, datos).subscribe(
      response => {
        if (response && !response['error']) {
          console.log('✅ Configuración paradas/informe guardada exitosamente');
          this.gtp.showSuccess('Configuración actualizada correctamente');
        } else {
          console.error('❌ Error:', response['msg']);
          this.gtp.showError(`Error: ${response['msg'] || 'Error al actualizar configuración'}`);
        }
      },
      error => {
        console.error('❌ Error request:', error);
        this.gtp.showError('Error de conexión al guardar configuración. Intente nuevamente.');
      }
    );
  }

}
